import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSC = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M41.877 6.556A24.908 24.908 0 0 0 25 0a25.25 25.25 0 0 0-3.144.196L9.784 14.13.792 31.263a24.845 24.845 0 0 0 2.615 6.34L25 25 41.877 6.556Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "m45.814 38.851-34.978 6.75A24.882 24.882 0 0 0 25 50c8.684 0 16.332-4.428 20.814-11.149Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M41.878 6.56 3.419 37.627a25.096 25.096 0 0 0 3.582 4.723L50 25c0-7.3-3.13-13.87-8.121-18.44Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M0 25c0 2.163.275 4.262.791 6.263L21.856.197C9.533 1.743 0 12.258 0 25Z"
}));
FlagSC.displayName = 'FlagSC';
export default withFlagWrapper(FlagSC);
//# sourceMappingURL=index.js.map